import React, { useCallback, useContext } from "react";
import { AppContext } from "../AppContext";
import { makeStyles } from "@material-ui/styles";
import { LinearProgress, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { ReactComponent as UploadingIcon } from '../assets/icons/uploading.svg';
import {  formatFileSize } from '../helpers/constants';
import FileCard from "./FileCard";


const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        overflowY: "auto",
        maxHeight: "calc(100vh - 220px)",
        //height: "100%"
    },
    card_container: {
        padding: theme.spacing(1),
        transition: "background-color 0.4s",
        boxShadow: "0px 0px 2px 2px rgba(0, 0, 0, 0.2)",
        "&:hover": {
            backgroundColor: '#eeeeee',
            boxShadow: "0px 0px 3px 3px rgba(0, 0, 0, 0.3)",
            transition: "background-color 0.4s",
        }
    },
    display_flex: {
        display: 'flex'
    },
    margin_left_auto: {
        marginLeft: 'auto'
    },
    flex_auto: {
        flex: 'auto'
    },
    cancel_icon: {
        color: '#888',
        cursor: 'pointer'
    },
    icon_container: {
        marginRight: '10px'
    },
    header: {
        fontSize: '14px'
    },
    nowrap: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    red: {
        backgroundColor: "red",
    }
}))

export default function FileUploadCards(props) {
    const classes = useStyles();
    const state = useContext(AppContext);
    const s = state.strings;

    const { acceptedFiles, fileStatus, onUploadedDeleteFile, isDragActive, singleFile, onUploadedEditFile } = props;

    const onDeleteFile = useCallback((e, id) => {
        e.stopPropagation();
        onUploadedDeleteFile(id);
    });

    const onEditFile = useCallback((e, id) => {
        e.stopPropagation();
        onUploadedEditFile(id);
    });

    return (

        (isDragActive) ?
            <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                <UploadingIcon fill="#1982DD" height={100} width={100} style={{ marginBottom: 16 }} />
                <Typography>{s.newCheck.dropFilesHere}</Typography>
            </div> :

            <Grid container direction="row" justify={singleFile ? "center" : "flex-start"} alignItems={singleFile ? "center" : "flex-start"}  spacing={2} className={classes.root}>
                {acceptedFiles.map((file, i) => {
                    const status = fileStatus.find(item => item.UploadId === file.id);
                    const statusLine = (status && status.Status == "Ok") ? s.newCheck.uploadFileWords.format(status.Words || '0', Math.ceil(status.Words / 250.0)) :
                        (status && (status.Status == "Active" || status.Status == "Scheduled")) ? s.analyzing + "..." :
                            (status && status.Status == "Error") ? s.newCheck.errorReadingFile :
                                s.uploading + "...";
                    const sizeLine = (status && status == "Error") ? null :
                        (status && file.size) ? formatFileSize(file.size) : file.id + "_status";
                    const progressValue = (status && status.Status == "Ok") ? 100 : null;
                    const externalProgress = !Boolean(status);


                    return (
                        <Grid xs={singleFile ? 8 : 6 } item key={i} >
                            <FileCard id={file.id} title={file.path} text1={statusLine} text2={sizeLine} onDelete={onUploadedDeleteFile ? onDeleteFile : null} onEdit={onUploadedEditFile ? onEditFile : null} progressValue={progressValue} externalProgress={externalProgress} />
                        </Grid>
                    )
                })
                }
            </Grid >

    )
}